import * as React from 'react';
const AnchorContext = React.createContext(undefined);
export default AnchorContext;
